'use client'

/**
 * Returns the device pixel ratio, which is the ratio of physical pixels to logical pixels.
 * This is useful for determining the correct font size for text on the page.
 *
 * @returns The device pixel ratio where 100 is equal to 1x, which is the ratio of physical pixels to logical pixels.
 */
export default function useDevicePixelRatio() {
  if (
    typeof window !== 'undefined' &&
    typeof window.devicePixelRatio === 'number'
  ) {
    return Math.round(window.devicePixelRatio * 100)
  }

  if (typeof screen !== 'undefined' && screen.width && window.innerWidth) {
    return Math.round((screen.width / window.innerWidth) * 100)
  }

  return 100
}
